import type { HelpFile } from '../../types/help'
import { LayoutActiveIndicatorTestIds } from '../../../testids/LayoutActiveIndicatorTestIds'

export const layoutActiveIndicatorHelp: HelpFile = {
  texts: {
    [LayoutActiveIndicatorTestIds.layoutActiveIndicator]:
      'Marks the form layout currently active for this entity type. Only one layout per type is rendered to end users at a time.',
  },
}
